import { Injectable } from '@angular/core';
import {environment} from "../../config/environment";
import {MyHttp} from "../../core/http";
import {ReplaySubject} from "rxjs/ReplaySubject";

@Injectable()
export class VideoService {

  private meetingStateObs$ = new ReplaySubject<{sessionId: string, token: string, apiKey: string}>();

  private streamObs$: ReplaySubject<any>;

  constructor(private http: MyHttp) {
    this.clearStreams();
  }

  getLink(jobId: number){
    return this.http.get(`${environment.API}/video/link/${jobId}`)
      .map(res => res.json());
  }

  exchangeToken(precallToken, precallSessionId){
    return this.http.post(`${environment.API}/video/exchange_token/${precallToken}/${precallSessionId}`, {})
      .map(res => res.json());
  }

  getMeetingState(){
    return this.meetingStateObs$;
  }

  setMeetingState(state){
    this.meetingStateObs$.next(state);
  }

  getStreams(){
    return this.streamObs$;
  }

  addStream(event){
    this.streamObs$.next(event);
  }

  clearStreams(){
    this.streamObs$ = new ReplaySubject<any>();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/video/video.service.ts